export const LIBRARY_TAB = 0;
export const SENT_TAB = 1;

/**
 * The URL is the single source of truth for which tab is open, so a notification deep-link
 * straight into `.../documents/sent` lands on the Sent documents tab without any extra state.
 */
export const getActiveTabFromPath = (pathname) =>
  (pathname ?? "").replace(/\/+$/, "").endsWith("/sent") ? SENT_TAB : LIBRARY_TAB;

export const buildTabPath = (universityId, tab) =>
  tab === SENT_TAB
    ? `/admin/university/${universityId}/documents/sent`
    : `/admin/university/${universityId}/documents`;
